import { useEffect, useState } from "react"
import { getFormatFecha } from "../../helpers/dates"
import PageController from "../pageController/PageController"
import './tbStyles.css'

export const TbUsers = ({ users, deleteUser }) => {

  const [usuarios, setUsuarios] = useState([])
  const [initData, setInitData] = useState(0)
  const pagesize = parseInt(process.env.REACT_APP_PAGE_RECORDS);

  useEffect(() => {
    const loadData = async () => {
      setUsuarios(await users.slice(initData, initData + pagesize));
    }
    loadData()
  }, [users, initData, pagesize]);

  return (
    <div className="table-container">
      <table cellSpacing='0'>
        <thead>
          <tr>
            <th>NOMBRE</th>
            <th className="responsive-movil" >PASSWORD</th>
            <th >ALIAS</th>
            <th className="responsive">NIVEL</th>
            <th className="responsive">FECHOR</th>
            <th colSpan={2}>ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(usuarios)
            ? usuarios.map((user) => (
              <tr key={user.USE_CLAVE}>
                <td >{user.USE_NOMBRE}</td>
                <td className="responsive-movil mulargo">{user.USE_PASSWORD}</td>
                <td>{user.USE_ALIAS}</td>
                <td className="responsive">{user.USE_NIVEL} </td>
                <td className="responsive">{getFormatFecha(user.USE_FECHOR)}</td>
                <td><button
                  onClick={() => deleteUser(user)}
                  className="material-icons-outlined">delete</button></td>

              </tr>
            ))
            : <h1>NO HAY DATOS EN LA TABLA</h1>}
        </tbody>
      </table>
      <section className="tbFooter">
        <PageController initData={initData} setInitData={setInitData} length={users.length} />
      </section>
    </div>
  )
}
export default TbUsers